import React, { useState, useEffect } from "react";
import Layout from "../../layout/Layout";
import { Form } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../utils/axiosConfig";
import * as CustomToast from "../../components/CustomToastMessage";
import BlogImageUpload from "../../components/blogImageUpload";

function CategoryEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: "",
    categoryImage: null,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/admin/category/${id}`
        );
        const category = response.data.data;
        setFormData({
          name: category.name || "",
          categoryImage: category.categoryImage || null,
          priority: category?.priority || "",
        });
      } catch (error) {
        console.error(
          error.response?.data?.message || "Error fetching category"
        );
        navigate("/category");
      }
    };
    if (id) fetchCategory();
  }, [id, navigate]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageUpload = (file) => {
    setFormData((prev) => ({ ...prev, categoryImage: file }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name) {
      CustomToast.error("Please enter a category name");
      return;
    }
    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("priority", formData?.priority || "");

    if (formData.categoryImage) {
      formDataToSend.append("categoryImage", formData.categoryImage);
    }
    setLoading(true);
    try {
      await axiosInstance.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/category/edit/${id}`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      CustomToast.success("Category updated successfully");
      navigate("/category");
    } catch (error) {
      if (error.response?.data?.status === 400) {
        CustomToast.error(error.response?.data?.message);
      }
      console.error(error.response?.data?.message || "Error updating category");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title="Edit Category">
      <main>
        <div className="card page-card">
          <div className="card-body">
            <div className="row g-3">
              <div className="col-12">
                <Form.Group controlId="categoryImage">
                  <Form.Label>Category Image</Form.Label>
                  <BlogImageUpload
                    onFileSelect={handleImageUpload}
                    initialImage={formData.categoryImage}
                  />
                </Form.Group>
              </div>
              <div className="col-6">
                <Form.Group controlId="name">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Enter category name"
                  />
                </Form.Group>
              </div>
              <div className="col-6">
                <Form.Group controlId="priority">
                  <Form.Label>Priority</Form.Label>
                  <Form.Control
                    type="number"
                    name="priority"
                    placeholder="Priority"
                    min="1"
                    step="1"
                    value={formData?.priority || ""}
                    onChange={handleInputChange}
                    onKeyDown={(e) => {
                      const { value } = e.target;

                      const invalidKeys = [
                        "e",
                        "E",
                        "+",
                        "-",
                        ".",
                        "ArrowDown",
                        "ArrowUp",
                      ];
                      if (
                        invalidKeys.includes(e.key) ||
                        (e.key === "0" && !value)
                      ) {
                        e.preventDefault();
                        return;
                      }
                    }}
                    onPaste={(e) => {
                      if (isNaN(e.clipboardData.getData("text"))) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-12 d-flex justify-content-end gap-3">
                <button
                  className="btn-outline fs-16 fw-700 px-4"
                  onClick={() => navigate("/category")}
                  type="button"
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  className="btn-primary fs-16 fw-700 px-4"
                  onClick={handleSubmit}
                  type="button"
                  disabled={loading}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export default CategoryEdit;
